import { useState } from "react";
import { useDidMount } from "./useDidMount";
import { isIeBrowser } from "../util";

export function useSupportBrowser(): boolean | undefined {
  const [supportBrowser, setSupportBrowser] = useState<boolean | undefined>(
    undefined
  );
  useDidMount(() => {
    setSupportBrowser(!isIeBrowser());
  });
  return supportBrowser;
}
